import React, { Fragment,useState } from "react";
import PropTypes from "prop-types";
import {
  useTable,
  useGlobalFilter,
  useAsyncDebounce,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
  useRowSelect,
} from "react-table";
import { Table, Row,Button } from "reactstrap";
import { DefaultColumnFilter } from "./filters";
import { ContactsGlobalFilter } from "./GlobalSearchFilter";
import { Link } from "react-router-dom";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";

function GlobalFilter({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
}) {
  const count = preGlobalFilteredRows.length;
  const [value, setValue] = React.useState(globalFilter);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 200);

  return (
    <input
      value={value || ""}
      onChange={(e) => {
        setValue(e.target.value);
        onChange(e.target.value);
      }}
      placeholder={`Rechercher dans ${count} enregistrements...`}
      className="form-control search"
      style={{ maxWidth: "300px", marginBottom: "1rem" }}
    />
  );
}
const TableContainerMin = ({
  columns,
  data,
  isGlobalFilter,
  isUsersFilter,
  handleUserClick,
  customPageSize,
  tableClass,
  theadClass,
  trClass,
  thClass,
  divClass,
  HeaderTable,
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: {
        pageIndex: 0,
        pageSize: customPageSize,
        selectedRowIds: 0,
        sortBy: [
          {
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };
  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  return (
    <Fragment>
      <Row className="">
        {isGlobalFilter && (
          <GlobalFilter
            preGlobalFilteredRows={preGlobalFilteredRows}
            globalFilter={state.globalFilter}
            setGlobalFilter={setGlobalFilter}
            isUsersFilter={isUsersFilter}
            handleUserClick={handleUserClick}
            HeaderTable={HeaderTable}
          />
        )}
      </Row>
      <div className={divClass}>
        <Table hover {...getTableProps()} className={tableClass}>
          <thead className={theadClass}>
            {headerGroups.map((headerGroup) => (
              <tr
                className={trClass}
                key={headerGroup.id}
                {...headerGroup.getHeaderGroupProps()}
              >
                {headerGroup.headers.map((column) => (
                  <th
                    key={column.id}
                    className={thClass}
                    {...column.getSortByToggleProps()}
                  >
                    {column.render("Header")}
                    {generateSortingIndicator(column)}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <Fragment key={row.getRowProps().key}>
                  <tr>
                    {row.cells.map((cell) => {
                      return (
                        <td key={cell.id} {...cell.getCellProps()}>
                          {cell.render("Cell")}
                        </td>
                      );
                    })}
                  </tr>
                </Fragment>
              );
            })}
          </tbody>
        </Table>
      </div>
 {data && data.length > 0 && (
  <Row className="align-items-center mt-2 g-3 text-center">
    <div className="d-flex align-items-center gap-2 justify-content-end">

      {/* Bouton Précédent */}
      <Button
        style={{ justifyContent: 'center', display: "flex", alignItems: "center", width: "27px", height: "27px" }}
        disabled={!canPreviousPage}
        onClick={() => previousPage()}
      >
        &laquo;
      </Button>
      {(() => {
        const totalPages = pageOptions.length;
        const maxPages = 5;

        let start = Math.max(pageIndex - Math.floor(maxPages / 2), 0);
        let end = start + maxPages;

        if (end > totalPages) {
          end = totalPages;
          start = Math.max(end - maxPages, 0);
        }
        return pageOptions.slice(start, end).map(i => (
          <Button
            key={i}
            onClick={() => gotoPage(i)}
            style={{
              backgroundColor: pageIndex === i ? "#396AFC" : "#F3F3F3",
              color: pageIndex === i ? "#FFFFFF" : "#000000",
              border: "1px solid #E3E3E3",
              fontWeight: 500,
              fontSize: "15px",
              fontFamily: 'Inter',
              width: "27px",
              height: "27px",
              justifyContent: 'center',
              display: "flex",
              alignItems: "center"
            }}
          >
            {i + 1}
          </Button>
        ));
      })()}

      {/* Bouton Suivant */}
      <Button
        style={{ justifyContent: 'center', display: "flex", alignItems: "center", width: "27px", height: "27px" }}
        disabled={!canNextPage}
        onClick={() => nextPage()}
      >
        &raquo;
      </Button>
    </div>
  </Row>
)}
    </Fragment>
    
  );
};
TableContainerMin.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default TableContainerMin;
